import { IconButton } from '@/lib';
import { TranslationKeys } from '@/localization';
import { toRuntimeTranslationKey } from '@/localization/translationKey';
import { PlusIcon } from '@heroicons/react/solid';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

export type HomeDataSectionActionProps = {
  path: string;
  text: TranslationKeys;
  className?: string;
  showButtonIcon?: boolean;
};

export const HomeDataSectionAction: FC<HomeDataSectionActionProps> = ({ path, text, showButtonIcon = true, className }) => {
  const { t } = useTranslation();

  return (
    <div className={twMerge('justify-self-center', className)}>
      <Link to={path} tabIndex={-1}>
        <IconButton text={t(toRuntimeTranslationKey(text) as any)} size='md' leadingIcon={showButtonIcon && <PlusIcon className='size-5' />} />
      </Link>
    </div>
  );
};
